import {Drawer} from 'antd';
import {useStore} from '@/store/root-store';
import styles from './style.module.scss';
import {observer} from 'mobx-react';
import styled from 'styled-components';
import {TabPane, Tabs} from '@/components/common-components';
import {getSingleUrlParam, copyAndModifyQueryParams} from '@/utils/url';
import {useRouter} from 'next/router';
import {useState, useEffect} from 'react';
import {FreeStockTab} from './pages/free-stock-tab';
import {AICreateImagesTab} from './pages/ai-create-images-tab';

interface Props {
  onChange: (editorState: any) => any;
}

export const AddImageDrawer = observer(({onChange}: Props) => {
  const {contentOptimizer: {
    aiOutline: {
      setCopyStatus,
    },
    currentPage,
  }} = useStore('');
  const {isUnsplashDrawerOpen, setIsUnspashDrawerOpen, setContentType} = currentPage;
  const checkTab = getSingleUrlParam('activeTab');
  const router = useRouter();
  const [activeTab, setActiveTab]= useState(router?.query?.activeTab || 'aiCreateImages');

  useEffect(() => {
    if (checkTab) {
      setActiveTab(checkTab);
    }
  }, [checkTab]);

  const handleClose = () => {
    setIsUnspashDrawerOpen(false);
    setActiveTab('aiCreateImages');
    setCopyStatus('Copy');
    setContentType('toArticle');

    const currentURL = window.location.href;
    const url = new URL(currentURL);
    const queryParams = new URLSearchParams(url.search);
    queryParams.delete('activeTab');
    const newURL = `${url.origin}${url.pathname}${queryParams.toString()}${url.hash}`;
    window.history.pushState({path: newURL}, '', newURL);
  };

  return (
    <>
      <Drawer
        destroyOnClose={true}
        visible={isUnsplashDrawerOpen}
        placement='right'
        mask={true}
        maskClosable={true}
        width='630px'
        onClose={() => {
          handleClose();
        }}
        bodyStyle={{backgroundColor: '#F2F2F5', padding: '0'}}
        className={styles.contentIdeasDrawer}
      >
        <TabsStyled>
          <Tabs
            tabBarGutter={20}
            activeKey={String(activeTab)}
            onChange={key => {
              setActiveTab(key);
              router.push(`${copyAndModifyQueryParams([{key: 'activeTab', value: key}])}`, undefined, {shallow: true});
            }}
          >
            <TabPane tab={<div>AI Create Images</div>} key='aiCreateImages'>
              <AICreateImagesTab store={currentPage} activeTab={activeTab} onChange={onChange} />
            </TabPane>
            <TabPane tab={<div>Free Stock</div>} key='freeStock'>
              <FreeStockTab onChange={onChange}/>
            </TabPane>
          </Tabs>
        </TabsStyled>
      </Drawer>
    </>
  );
});

const TabsStyled = styled.div`
padding: 0 20px 20px 20px;
  .rc-tabs-nav {
    background: transparent !important;
    border-bottom: 1px solid #E8E8E8;
    height: 70px !important;
  }
  .rc-tabs-content-holder {
    border-radius: 13px;
    background: transparent !important;
  }
  .rc-tabs-tab-btn {
    font-size: 16px !important;
    color: #4E5156 !important;
  }
  .rc-tabs-tab-active {
    .rc-tabs-tab-btn  {
     font-size: 16px !important;
     font-weight: 500 !important;
     line-height: 22px !important;
     color: #121212 !important;
    }
  }
  .rc-tabs-ink-bar {
    position: absolute !important;
    bottom: 0px;
    height: 5px !important;
    background: #7F4EAD !important;
    box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.02) !important;
    border-radius: 4px 4px 0px 0px !important;
  }
`;
